import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-generate-control-sheets-po-p',
  templateUrl: './generate-control-sheets-po-p.component.html',
  styleUrls: ['./generate-control-sheets-po-p.component.scss']
})
export class GenerateControlSheetsPoPComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
